export const compare = (a: any, b: any, isAsc: boolean) => {
  if (a === null) a = '';
  if (b === null) b = '';
  return (a.toLowerCase().localeCompare(b.toLowerCase()) ? 1 : -1) * (isAsc ? 1 : -1);
}
